import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import _some from 'lodash/some'
import { Row, Col, Button, Alert, Fade } from 'react-bootstrap'

import Loading from '../../components/shared/Loading'
import { history } from '../../store'
import { connect } from 'react-redux'
import {
  getUsersByBrokerage,
  updateUser,
  createNewUser,
} from './../../actions/adminActions'
import { removeAlert } from '../../alerts'

import { fetch as fetchInvites, remove as removeInvite } from './../../invites/actions'
import { fetchLockedUsers } from '../../users/actions'

import TableComponent from './../../components/shared/TableComponent'
import DialogBox from './../../components/shared/DialogBox'
import EditUserModal from './EditUserModal'
import NewUser from './NewUser'
import { unlock as unlockUser } from '../../../lib/authentication'
import { assignUserToGroup, unassignUserToGroup } from '../../users/api'

export class UserManagement extends Component {
  constructor() {
    super()
    this.state = {
      showEditModal: false,
      showUnlockModal: false,
      invites: {},
      activeUsers: [],
      lockedUsers: [],
      unlockUser: '',
      unlockSubtitle:
        'Unlocking the user will set the users profile to Active and allow them to log in to Owners Edge',
      isLoading: false,
      alert: '',
    }

    this.handleDisableUser = this.handleDisableUser.bind(this)
    this.handleEnableUser = this.handleEnableUser.bind(this)
    this.handleCreateUser = this.handleCreateUser.bind(this)
    this.handleDeleteUser = this.handleDeleteUser.bind(this)
    this.handleResendUser = this.handleResendUser.bind(this)
    this.handleEditUser = this.handleEditUser.bind(this)
    this.hideEditModal = this.hideEditModal.bind(this)
    this.handleDismissAlert = this.handleDismissAlert.bind(this)
    this.handleUnlockUser = this.handleUnlockUser.bind(this)
    this.hideUnlockModal = this.hideUnlockModal.bind(this)
    this.handleConfirmUnlockModal = this.handleConfirmUnlockModal.bind(this)
  }

  // determine if user is a broker or underwriter
  getUserManagerType() {
    if (!this.canManageUsers()) {
      return undefined
    }

    if (this.props.user.role.includes('underwriter')) {
      return 'underwriter'
    }
    return 'broker'
  }

  canManageUsers() {
    if (!this.props.user) return false
    if (this.props.user.role.includes('admin')) return true // for legacy users!!!
    if (!this.props.user.permissions) return false
    return _some([
      this.props.user.permissions.includes('underwriters:write'),
      this.props.user.permissions.includes('brokers:write'),
    ])
  }

  componentWillMount() {
    if (!this.canManageUsers()) {
      history.push('/submissions')
    } else {
      this.props.dispatch(getUsersByBrokerage(this.props.user))
      this.props.dispatch(fetchInvites())
      this.props.dispatch(fetchLockedUsers())
    }
  }

  componentDidMount() {
    // move the pagination totals to the top of the tables
    const totals = document.querySelectorAll('.pagination-total')

    function ancestor(el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el
    }

    // workaround for IE!
    Array.prototype.forEach.call(totals, (el) => {
      const tableContainer = ancestor(el, 'react-bs-table-container'),
        toolbar = tableContainer.querySelector('.react-bs-table-tool-bar')
      if (toolbar) toolbar.appendChild(el)
    })
  }

  componentWillReceiveProps(props) {
    if (props.users) {
      this.setState({
        activeUsers: props.users.filter(
          (user) =>
            user.status === 'active' ||
            user.status === 'disabled' ||
            user.status === 'revoked',
        ),
        lockedUsers: props.lockedUsers?.map((a) => {
          return {
            email: a.profile.email,
            firstName: a.profile.firstName,
            lastName: a.profile.lastName,
            lastOnline: a.lastLogin,
            role: a.role,
            status: 'locked',
          }
        }),
      })
    }
  }

  hideEditModal() {
    this.setState({
      ...this.state,
      showEditModal: false,
      selectedUser: null,
    })
  }

  hideUnlockModal() {
    this.setState({
      ...this.state,
      showUnlockModal: false,
      selectedUser: null,
      unlockSubtitle:
        'Unlocking the user will set the users profile to Active and allow them to log in to Owners Edge',
    })
  }

  handleDisableUser(row) {
    this.props.dispatch(updateUser(row, 'disabled', this.props.user))
    unassignUserToGroup(row.username)
      .catch((e) => {
        console.log(e.message)
      })
  }

  handleEnableUser(row) {
    this.props.dispatch(updateUser(row, 'active', this.props.user))
    assignUserToGroup(row.username)
      .catch((e) => {
        console.log(e.message)
      })
  }

  handleUnlockUser(row) {
    this.setState({
      ...this.state,
      showUnlockModal: true,
      unlockUser: row,
    })
  }

  handleConfirmUnlockModal() {
    const { email } = this.state.unlockUser
    this.setState({
      isLoading: true,
    })
    unlockUser(email)
      .then((r) => {
        this.setState({
          unlockSubtitle: 'The user account has been successfully unlocked',
          isLoading: false,
        })
        this.props.dispatch(fetchLockedUsers())
      })
      .catch((err) => {
        console.error(err)
        this.setState({
          unlockSubtitle: 'Failed to unlocked the user. Please try after sometime',
          isLoading: false,
        })
      })
  }

  handleEditUser(row) {
    this.setState({
      ...this.state,
      showEditModal: true,
      selectedUser: row,
    })
  }

  handleCreateUser(email, isAdmin) {
    const { user } = this.props
    this.props.dispatch(createNewUser(email, user, isAdmin))
  }

  handleDeleteUser(invite) {
    this.props.dispatch(removeInvite(invite))
  }

  handleResendUser(invite) {
    const { user } = this.props
    const { username } = invite
    this.props.dispatch(createNewUser(username, user))
  }

  handleDismissAlert(alert) {
    if (this.props.removeAlert) {
      this.props.removeAlert(alert)
    }
  }

  render() {
    const user = this.props.user
    const activeUsers = {
      data: this.state.activeUsers,
      columns: [
        {
          dataField: 'email',
          width: '22%',
          isKey: true,
          title: 'Email',
          isSortable: true,
        },
        {
          dataField: 'firstName',
          title: 'First Name',
          isSortable: true,
          width: '11%',
        },
        {
          dataField: 'lastName',
          title: 'Last Name',
          isSortable: true,
          width: '11%',
        },
        {
          dataField: 'admin',
          width: '7.5%',
          title: 'Admin',
          dataFormat: (cell, row) => {
            return row.role.includes('admin') ? 'Yes' : ''
          },
        },
        {
          isKey: false,
          title: 'Last Online',
          width: '120px',
          dataFormat: (cell, row) =>
            (!Number.isNaN(Date.parse(row.lastOnline)) &&
              moment(row.lastOnline).format('MM/DD/YY h:mm a')) ||
            '',
        },
        {
          dataField: 'status',
          width: '7.5%',
          title: 'Status',
          dataFormat: (cell, row) => {
            return row.status === 'active' ? (
              <div className="activeStatus">Active</div>
            ) : (
              <div className="disabledStatus">{row.status}</div>
            )
          },
        },
        {
          width: '140px',
          title: 'Update',
          dataFormat: (cell, row) => {
            const result = () => {
              if (user.id === row.id) {
                return (
                  <div className="updateColumn">
                    <Button
                      onClick={() => {
                        return this.handleEditUser(row)
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                )
              } else if (row.status === 'active') {
                return (
                  <div className="updateColumn">
                    <Button
                      onClick={() => {
                        return this.handleEditUser(row)
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => {
                        return this.handleDisableUser(row)
                      }}
                    >
                      Disable
                    </Button>
                  </div>
                )
              } else if (row.status === 'disabled') {
                return (
                  <div className="updateColumn">
                    <Button
                      onClick={() => {
                        return this.handleEditUser(row)
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      onClick={() => {
                        return this.handleEnableUser(row)
                      }}
                    >
                      Enable
                    </Button>
                  </div>
                )
              } else if (row.status === 'revoked') {
                return (
                  <div className="updateColumn">
                    <Button
                      onClick={() => {
                        return this.handleEditUser(row)
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                )
              }
              return <div />
            }

            return result()
          },
        },
      ],
    }

    const lockedUsers = {
      data: this.state.lockedUsers,
      columns: [
        {
          dataField: 'email',
          width: '22%',
          isKey: true,
          title: 'Email',
          // isSortable: true
        },
        {
          dataField: 'firstName',
          width: '10%',
          title: 'FirstName',
        },
        {
          dataField: 'lastName',
          width: '10%',
          title: 'LastName',
        },
        {
          dataField: 'admin',
          width: '7.5%',
          title: 'Admin',
          dataFormat: (cell, row) => {
            return row.role.includes('admin') ? 'Yes' : ''
          },
        },
        {
          isKey: false,
          title: 'Last Online',
          width: '120px',
          dataField: 'lastOnline',
          dataFormat: (cell, row) =>
            (!Number.isNaN(Date.parse(row.lastOnline)) &&
              moment(row.lastOnline).format('MM/DD/YY h:mm a')) ||
            '',
        },
        {
          dataField: 'status',
          width: '7.5%',
          title: 'Status',
          dataFormat: (cell, row) => {
            return <div className="disabledStatus">{row.status}</div>
          },
        },
        {
          width: '140px',
          title: 'Unlock',
          dataFormat: (cell, row) => {
            const result = () => {
              return (
                <div className="updateColumn">
                  <Button
                    onClick={() => {
                      return this.handleUnlockUser(row)
                    }}
                  >
                    unlock
                  </Button>
                </div>
              )
            }

            return result()
          },
        },
      ],
    }

    const { invites } = this.props

    const invitesList = {
      data: invites.items.filter(
        (invite) => String(invite.role).search(/underwriter/) < 0,
      ),
      columns: [
        {
          dataField: 'username',
          width: '35%',
          isKey: true,
          title: 'Email',
          isSortable: true,
        },
        {
          dataField: 'admin',
          width: '20%',
          isKey: false,
          title: 'Admin',
          dataFormat: (cell, row) => {
            return row.role.includes('admin') ? 'Yes' : ''
          },
        },
        {
          isKey: false,
          title: 'Invited',
          dataFormat: (cell, row) => moment(row.invitedAt).format('MM/DD/YY'),
        },
        {
          isKey: false,
          title: 'invitedHiddenSort',
          hidden: true,
          dataField: 'dateCreated',
        },
        {
          width: '176px',
          isKey: false,
          title: 'Update',
          dataFormat: (cell, row) => {
            return (
              <div className="updateColumn">
                <Button
                  onClick={() => {
                    this.handleResendUser(row)
                  }}
                  disabled={user.brokerage?.status === 'disabled'}
                >
                  Resend
                </Button>
                <Button
                  className="cancel-button"
                  onClick={() => {
                    this.handleDeleteUser(row)
                  }}
                >
                  Cancel
                </Button>
              </div>
            )
          },
        },
      ],
    }

    const userType = this.getUserManagerType()

    const userTypeLabel = userType === 'broker' ? 'brokers' : 'users'
    const manageUsersListTitle = user.brokerId
      ? `${user.brokerName} ${userTypeLabel}`
      : user.brokerName

    return (
      <div className="homepageContainer">
        <div className="container">
          <Row>
            <div className="userManagement routeContainer">
              {this.props.alerts.map((alert, index) => {
                return (
                  <Fade key={index} in={true} timeout={4000}>
                    <Alert
                      bsStyle={alert.type}
                      onDismiss={() => this.handleDismissAlert(alert)}
                    >
                      <div>{alert.message}</div>
                    </Alert>
                  </Fade>
                )
              })}
              <div>
                <Row>
                  <Col xs={12} sm={10} md={4} lg={4}>
                    <NewUser
                      data={{
                        brokerName: user.brokerName,
                        brokerId: user.brokerId,
                        userType: userType,
                        brokerStatus: user.brokerage?.status
                      }}
                      handleCreateUser={this.handleCreateUser}
                    />
                  </Col>
                  {
                    <Col xs={12} sm={10} md={8} lg={8}>
                      <Row className="row lockedUserContainer">
                        <Col xs={12}>
                          <TableComponent
                            title="Locked users"
                            data={lockedUsers.data}
                            columns={lockedUsers.columns}
                            options={{
                              defaultSortName: 'lastOnline',
                              defaultSortOrder: 'desc',
                              sizePerPage: 5,
                              pageStartIndex: 1,
                              paginationSize: 3,
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  }
                  {invitesList.data.length > 0 && (
                    <Col xs={12} sm={10} md={8} lg={8}>
                      <Row>
                        <Col xs={12} className="pending-table">
                          <TableComponent
                            title="Pending invites"
                            data={invitesList.data}
                            columns={invitesList.columns}
                            options={{
                              defaultSortName: 'dateCreated',
                              defaultSortOrder: 'desc',
                              sizePerPage: 5,
                              pageStartIndex: 1,
                              paginationSize: 3,
                            }}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col lg={12}>
                    <TableComponent
                      title={manageUsersListTitle}
                      options={{
                        sizePerPage: 5,
                        pageStartIndex: 1,
                        paginationSize: 3,
                        defaultSortName: 'email',
                        defaultSortOrder: 'asc',
                      }}
                      data={activeUsers.data.sort((a, b) => {
                        return +!b.username.localeCompare(user.username)
                      })}
                      columns={activeUsers.columns}
                    />
                  </Col>
                </Row>
              </div>
              <DialogBox
                title="Edit User"
                custom_class="editModal"
                show={this.state.showEditModal}
                onHide={this.hideEditModal}
              >
                <EditUserModal
                  selectedUser={this.state.selectedUser}
                  loggedInUser={this.props.user}
                  hideEditModal={this.hideEditModal}
                />
              </DialogBox>
              <DialogBox
                custom_class="confirmationDialog"
                title="Unlock user"
                subtitle={this.state.unlockSubtitle}
                show={this.state.showUnlockModal}
                onHide={this.hideUnlockModal}
              >
                {this.state.unlockSubtitle.startsWith('Unlocking') && (
                  <Button className="btn" onClick={this.handleConfirmUnlockModal}>
                    {this.state.isLoading === true ? (
                      <Loading width="20px" height="20px" classes="spinner" />
                    ) : (
                      'Confirm'
                    )}
                  </Button>
                )}
                {this.state.unlockSubtitle.startsWith('Unlocking') && (
                  <Button
                    className="btn secondary"
                    onClick={this.hideUnlockModal}
                    disabled={this.state.isLoading}
                  >
                    Cancel
                  </Button>
                )}
              </DialogBox>
            </div>
          </Row>
        </div>
      </div>
    )
  }
}

UserManagement.propTypes = {
  user: PropTypes.object,
  dispatch: PropTypes.func,
  users: PropTypes.array,
  invites: PropTypes.object,
  alerts: PropTypes.array.isRequired,
  removeAlert: PropTypes.func.isRequired,
}

export default connect(
  (store) => {
    return {
      user: store.user,
      showEditModal: true,
      users: store.admin.users,
      invites: store.invites,
      alerts: store.alerts.items,
      lockedUsers: store.users.lockedUsers,
    }
  },
  (dispatch) => ({
    dispatch,
    removeAlert: (...args) => dispatch(removeAlert(...args)),
  }),
)(UserManagement)
